
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "../Styles/Career.css";

const Career = () => {

  const handleApply = () => {
    window.location.href = "mailto:hr@swastikainfra.com?subject=Job Application";
  };

  // HASH SCROLL FIX
  useEffect(() => {
    window.history.scrollRestoration = "manual";

    const hash = window.location.hash;

    if (hash) {
      const element = document.querySelector(hash);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: "smooth" });
        }, 100);
      }
    } else {
      window.scrollTo(0, 0);
    }
  }, []);

  const jobs = [
  // {
  //   title: "Project Manager",
  //   dept: "Experience : 10-15 years (HT & LT Underground Cabling)",
  //   vacancy : "Vacancies : 1",
  //   Qualification : "Qualification : B.Tech Electrical",
  //   location: "Jaipur",
  // },
  {
    title: "Sr. Site Engineer",
    dept: "Experience : 5+ years (HT & LT Underground Cabling)",
    vacancy : "Vacancies : 3",
    Qualification : "Qualification :  B.Tech Electrical / Diploma",
    // location: "Jaipur",
  },
    {
    title: "Site Supervisor",
    dept: "Experience : 3–4 years of experience in power/EPC projects",
    vacancy : "Vacancies : 2",
    Qualification : "Qualification :  ITI / Diploma in Electrical preferred",
    // location: "Himachal Pradesh &  Gujarat",
  },
 
];

  return (
    <>

      <div className="career-image" id="join">
        <img src="./corporate/CAREER.png" alt="" />
      </div>

<section className="career-wrapper">

<div className="bgcolor">
        {/* LEFT SIDE (Tera SAME code - no change) */}
      <div className="left-side">

        <section className="join-section">
          <h2>Join Our Team</h2>
          <p className="subtitle">
             Our most valuable resources are our people, who carry forth our
            traditions, values, and long-standing reputation for performance.
            We take pride in investing the time and energy to recruit the best
            talent in our industry.
          </p>

          <div className="job-grid">
            {jobs.map((job, index) => (
              <div className="job-card" key={index}>
                <h3>{job.title}</h3>

                <div className="job-info">
                  <p>{job.dept}</p>
                  <p>{job.vacancy}</p>
                  <p>{job.Qualification}</p>
                  <p>{job.location}</p>
                </div>

                <Link to="mailto:hr@swastikainfra.com?subject=Job Application">
                  <button className="apply-btn">Apply</button>
                </Link>
              </div>
            ))}
          </div>
        </section>

      </div>

      {/* RIGHT SIDE (Form) */}
<div className="right-side">
  <form className="career-form">

    <div className="form-row">
      <input type="text" placeholder="Name" />
      <input type="email" placeholder="Email Address" color="#FFF" />
    </div>

    <div className="form-row">
      <input type="text" placeholder="Phone" />
      <input type="text" placeholder="Age" />
    </div>

   

    {/* <div className="form-group">
      <label>Applying for</label>
      <select>
        <option>Project Manager</option>
        <option>Sr. Site Engineer</option>
      </select>
    </div> */}

    <div className="form-row">
      <textarea placeholder="Text"></textarea>
    </div>

    <div className="form-group file-upload">
      <label>Upload Resume</label>
      <input type="file" />

    <button type="submit" className="submit-btn">
      Submit
    </button>


    </div>
   
   
  </form>
</div>
</div>

</section>


      <section>

        {/* <div className="careers-section">
          <h1 className="careers-title" >Join Our Team</h1>

          <p className="careers-desc">
            Our most valuable resources are our people, who carry forth our
            traditions, values, and long-standing reputation for performance.
            We take pride in investing the time and energy to recruit the best
            talent in our industry.
          </p>

          <p className="careers-email">
            To join our organization mail your resume at{" "}
            <a
              href="https://mail.google.com/mail/?view=cm&fs=1&to=hr@swastikainfra.com&su=Job Application"
              target="_blank"
              rel="noopener noreferrer"
            >
              hr@swastikainfra.com
            </a>
          </p>

          
          <div className="job-grid">
            <div className="job-card">
              <h3>Project Manager</h3>
              <ul>
                <li>Experience : 10-15 years (HT & LT Underground Cabling)</li>
                <li>Vacancies : 1</li>
                <li>Qualification : B.Tech Electrical</li>
              </ul>
            </div>

            <div className="job-card">
              <h3>Sr. Site Engineer</h3>
              <ul>
                <li>Experience : 5+ years (HT & LT Underground Cabling)</li>
                <li>Vacancies : 3</li>
                <li>Qualification : B.Tech Electrical / Diploma</li>
              </ul>
            </div>

            <div className="job-card">
              <h3>Site Supervisor</h3>
              <ul>
                <li>Experience : 3+ years (HT & LT Underground Cabling)</li>
                <li>Vacancies : 2</li>
                <li>Qualification : ITI Electrical</li>
              </ul>
            </div>
          </div>

          <div className="apply-btn-wrap">
            <a
              href="https://mail.google.com/mail/?view=cm&fs=1&to=hr@swastikainfra.com&su=Job Application"
              target="_blank"
              rel="noopener noreferrer"
              className="apply-btn"
            >
              Apply Now
            </a>
          </div>

        </div> */}

        {/* <div className="benefits-section" id="benefits">
          <div className="benefits-container">

            <div className="benefits-left">
              <span className="benefits-tag">
                <h3>WHY JOIN US</h3>
              </span>

              <p>
                We believe in growing together. Our team works in a positive,
                transparent, and professional environment where skills,
                dedication, and honesty are always valued.
              </p>
            </div>

            <div className="benefits-right">

              <div className="benefit-box">
                <h4>Career Growth</h4>
                <p>Opportunities to learn, grow, and build a long-term career.</p>
              </div>

              <div className="benefit-box">
                <h4>Supportive Team</h4>
                <p>Friendly work culture with experienced professionals.</p>
              </div>

              <div className="benefit-box">
                <h4>On-site Experience</h4>
                <p>Hands-on experience in large-scale electrical projects.</p>
              </div>

            </div>

          </div>
        </div> */}

      </section>
    </>
  );
};

export default Career;